import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useDispatch, useSelector } from 'react-redux';
import { post } from 'app/shared/utils/fetchr';
import { sendErrorToast, sendSuccessToast } from 'app/shared/toasts/actions';
import { RISK_MODEL_QUERY_KEYS } from 'app/modules/riskRatings/queries/keys';
import { RISK_SCORE_QUERY_KEYS } from 'app/modules/riskScore/queries/keys';
import { selectCrrRiskScoreFlatteningEnabled } from 'app/shared/featureFlags/selectors';

export const useClearRiskScoreOverride = (entityExternalId: string) => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();
  const isFlatteningEnabled = useSelector(selectCrrRiskScoreFlatteningEnabled);
  return useMutation({
    mutationFn: () => {
      const apiVersion = isFlatteningEnabled ? 'v2' : 'v1';
      return post(`/${apiVersion}/risk/entities/${entityExternalId}/override`);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: RISK_SCORE_QUERY_KEYS.getEntityRiskScore(entityExternalId),
      });
      queryClient.invalidateQueries({
        queryKey:
          RISK_MODEL_QUERY_KEYS.fetchOverriddenEntitiesByRiskModelBase(),
      });
      dispatch(sendSuccessToast('Successfully removed risk score override.'));
    },
    onError: () =>
      dispatch(
        sendErrorToast(
          'Failed to remove risk score override. Please try again.',
        ),
      ),
  });
};
